import { formatCurrency } from '../utils';
import type { OrderRecord } from '../types';
import './OrderDetailDrawer.scss';

interface OrderDetailDrawerProps {
  open: boolean;
  record?: OrderRecord | null;
  onClose: () => void;
}

export function OrderDetailDrawer({ open, record, onClose }: OrderDetailDrawerProps) {
  if (!open || !record) return null;

  return (
    <div className="order-detail-drawer">
      <div className="order-detail-drawer__overlay" onClick={onClose} />
      <div className="order-detail-drawer__panel">
        <div className="drawer-header">
          <div>
            <p className="drawer-label">Chi tiết đơn hàng</p>
            <h5 className="mb-1">{record.code}</h5>
            <p className="text-muted mb-0">{record.customer?.name ?? 'Chưa xác định khách hàng'}</p>
          </div>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
        </div>

        <div className="drawer-body">
          <div className="drawer-section">
            <p className="section-title">Thông tin chung</p>
            <ul className="info-list">
              <li>
                <span>Mã đơn</span>
                <strong>{record.code}</strong>
              </li>
              <li>
                <span>Khách hàng</span>
                <strong>{record.customer?.name ?? '—'}</strong>
              </li>
              <li>
                <span>Tổng tiền</span>
                <strong>{formatCurrency(record.total_amount)}</strong>
              </li>
              <li>
                <span>Trạng thái</span>
                <strong className={`status status--${record.status}`}>{record.status}</strong>
              </li>
              <li>
                <span>Ngày tạo</span>
                <strong>{record.created_at ? new Date(record.created_at).toLocaleString('vi-VN') : '—'}</strong>
              </li>
            </ul>
          </div>

          <div className="drawer-section">
            <p className="section-title">Danh sách gói</p>
            <div className="detail-table">
              <div className="detail-table__head">
                <span>Gói</span>
                <span>Số lượng</span>
                <span>Đơn giá</span>
                <span>Thành tiền</span>
              </div>
              {(record.order_details ?? []).map((detail) => (
                <div key={detail.id} className="detail-table__row">
                  <span>{detail.package_name ?? detail.package_code ?? detail.package_id}</span>
                  <span>x{detail.quantity}</span>
                  <span>{formatCurrency(detail.price)}</span>
                  <strong>{formatCurrency(detail.total_price)}</strong>
                </div>
              ))}
            </div>
          </div>

          {record.notes && (
            <div className="drawer-section">
              <p className="section-title">Ghi chú</p>
              <p className="text-muted mb-0">{record.notes}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


